import { ChangeDetectionStrategy, Component, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { NotificationItemComponent } from '../item/notification-item.component';
import { NNotification } from '../notification.interfaces';
@Component({
    selector: 'notification-area',
    template: '<div #parent></div>',
    styleUrls: ['notification-area.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationAreaComponent {
    constructor(private componentFactoryResolver: ComponentFactoryResolver) {}
    @ViewChild('parent', { read: ViewContainerRef, static: true })
    entry!: ViewContainerRef;
    add(data: NNotification.IData) {
        const factory = this.componentFactoryResolver.resolveComponentFactory(NotificationItemComponent);
        const componentRef = this.entry.createComponent(factory);
        componentRef.instance.data = data;
        componentRef.instance.componentRef = componentRef;
        componentRef.changeDetectorRef.detectChanges();
    }
}
